import React from "react";

export default function Placeholder2() {
  return (
    <>
      <div className="Body">
        <header>
          <span className="text-decoration-underline">Placeholder2</span>
        </header>
      </div>
    </>
  );
}
